import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { makeStyles } from '@material-ui/core';
import Fields from 'components/Fields';

const useStyles = makeStyles({
  form: {
    width: '20rem',
    padding: '1rem'
  },
  btn: {
    width: '100%'
  },
  field: {
    margin: '0.5rem 0 '
  },
  btnContainer: {
    marginTop: '1rem',
    display: 'flex'
  }
});

const Customer = () => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <Field
        name="first_name"
        label="First name"
        validate={Fields.Validators.required}
        component={Fields.Text}
        className={classes.field}
      />
      <Field
        name="last_name"
        label="Surname"
        validate={Fields.Validators.required}
        component={Fields.Text}
        className={classes.field}
      />
    </React.Fragment>
  );
};

export default reduxForm({})(Customer);
